<h1 mat-dialog-title><span i18n>Upozornenie</span></h1>
<hr/>
<mat-dialog-content class="alert p-3 m-3 rounded">
  {{data.message}}
</mat-dialog-content>
<hr/>
<mat-dialog-actions class="d-flex justify-content-end">
  <button class="btn" mat-dialog-close cdkFocusInitial><span i18n>Close</span></button>
</mat-dialog-actions>
